import React, { useEffect } from 'react';
import { Card } from 'antd';
import ReturnList from '../../components/Return/ReturnList';
import { useReturn } from '../../store/returnContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const ReturnListPage: React.FC = () => {
    const { fetchReturns } = useReturn();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        fetchReturns();
    }, []);

    const handleEdit = (ret: any) => {
        navigate(`/returns/form/${ret.id || ret._id}`);
    };

    return (
        <div style={{ padding: 16 }}>
            <Card title={t('returnList')} variant="outlined">
                <ReturnList onEdit={handleEdit} />
            </Card>
        </div>
    );
};

export default ReturnListPage;
